export default function FAQ() {
  const faqs = [
    {
      question: '「朋友的姐姐」这个主题为什么能引起这么多人的共鸣？',
      answer: '因为这是青春期最常见、最真实的情感体验之一。朋友的姐姐兼具"可接近"和"有距离"的双重特质，完美契合了少年的情感投射需求。几乎每个男生都能从这段经历中找到自己的影子。',
    },
    {
      question: '暗恋朋友的姐姐是正常的心理现象吗？',
      answer: '完全正常。这是青春期情感发展过程中的一种常见现象，是少年对异性产生好感的自然表达。心理学研究表明，这种"安全的暗恋"实际上是青少年情感能力发展的重要环节，有助于建立健康的情感认知。',
    },
    {
      question: '如何判断自己是"暗恋"还是"崇拜"？',
      answer: '暗恋通常伴随着心跳加速、紧张不安、以及对接触的渴望；而崇拜则更多是欣赏和仰望，没有太强的情感波动。如果你在她面前会紧张到手心出汗、说话结巴，那大概率是暗恋。如果你只是觉得她很优秀、想成为像她那样的人，那更接近崇拜。',
    },
    {
      question: '这种情感经历对成长有什么积极意义？',
      answer: '暗恋朋友的姐姐是情感成长的"练习场"。它帮助少年学会管理情感、提升自我要求、建立审美体系，并在"注定没有结果"的过程中学会释怀和成长。这段经历为你日后的情感交往奠定了重要基础。',
    },
    {
      question: '如果现在还忘不掉那个姐姐怎么办？',
      answer: '怀念不等于还爱着。大多数人怀念的不是那个人本身，而是那个因为她而变得更好的自己，以及那段纯粹到不掺杂任何杂质的青春时光。这种怀念是健康的，它说明你曾经真实地活过、爱过。接纳这种感受，然后继续向前走。',
    },
    {
      question: '暗恋朋友的姐姐和暗恋同龄女生有什么不同？',
      answer: '最大的不同在于"安全感"。同龄女生是"可能的恋爱对象"，暗恋带来的是期待和焦虑的混合体。而朋友的姐姐从一开始就是"不可能的人"，所以暗恋变得更加纯粹——不追求结果，只享受过程。这种无忧无虑的单向情感，往往比真正的恋爱更让人怀念。',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">常见问题</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">关于青春暗恋，你想知道的都在这里</p>
        </div>
        <dl className="space-y-4">
          {faqs.map((faq, index) => (
            <details key={index} className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-100 transition-colors duration-200 list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-8">{faq.question}</h3>
                <i className="ri-add-line text-lg text-foreground-500 group-open:hidden flex-shrink-0"></i>
                <i className="ri-subtract-line text-lg text-primary-500 hidden group-open:block flex-shrink-0"></i>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </dl>
      </div>
    </section>
  );
}